import {Injectable} from '@angular/core';
import {RouterStateSnapshot, TitleStrategy} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';


@Injectable()
export class AppSuffixTitleStrategy extends TitleStrategy {
  constructor(private readonly titleService: Title, private readonly translate: TranslateService) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const titlePrefixId = this.buildTitle(snapshot);
    if (titlePrefixId !== undefined) {
      // set the page title from translate resource
      this.translate.get(titlePrefixId).subscribe((titlePrefix: string) => {
        if (!!titlePrefix) {
          this.titleService.setTitle(`${titlePrefix} - DATEV MyUpdates`);
        } else {
          this.titleService.setTitle('DATEV MyUpdates');
        }
      });
    }
  }

}
